module.exports = __webpack_public_path__ + "static/media/jewellery-store.2ca5b151.jpg";